import yup from '../../../config/yup';

export const salesforceBulkReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('salesforceBulkReader'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  format: yup.string(),
  properties: yup.object().shape({
    useBearerToken: yup.boolean().default(false),
    username: yup.string().when('useBearerToken', {
      is: false,
      then: () => yup.string().required('Username is required when bearer token is not used'),
      otherwise: () => yup.string().notRequired(),
    }),
    password: yup.string().when('useBearerToken', {
      is: false,
      then: () => yup.string().required('Password is required when bearer token is not used'),
      otherwise: () => yup.string().notRequired(),
    }),
    isSandbox: yup.boolean(),
    query: yup.string().required('Query is required'),
    charsToBeEncoded: yup.string(),
  }),
});
